import React from 'react';
import DataServiceTabNav from '../Components/DataService/DataServiceTabNav';
import ConfigComponent from '../Components/DataService/ConfigComponent';

function DataServiceConfigPage() {
  return (
    <div className="bg-slate-950 text-slate-100">
      <DataServiceTabNav />
      <ConfigComponent />
    </div>
  );
}

export default DataServiceConfigPage;
